import { formatDateToYYYYMMDD } from "@/utils/time"

import { DateRange, Period } from "@/protocols/wabaUsageStatement"

export const calculateDateRange = (period: Exclude<Period, "custom">): DateRange => {
	const todayDate = new Date()

	if (period === "yesterday") {
		const yesterdayDate = new Date(todayDate)
		yesterdayDate.setDate(todayDate.getDate() - 1)
		const yesterdayStr = formatDateToYYYYMMDD(yesterdayDate)
		return { from: yesterdayStr, to: yesterdayStr }
	}

	const todayStr = formatDateToYYYYMMDD(todayDate)

	const periodToDaysBack: Record<Exclude<Period, "custom" | "yesterday">, number> = {
		7: 6,
		30: 29
	}

	const daysBack = periodToDaysBack[period]
	const pastDate = new Date(todayDate)
	pastDate.setDate(todayDate.getDate() - daysBack)
	return { from: formatDateToYYYYMMDD(pastDate), to: todayStr }
}

export const getEndDateLimit = (): Date => {
	return new Date()
}
